import { render } from "./LabelDetail.vue?vue&type=template&id=8d100cfe&scoped=true"
import script from "./LabelDetail.vue?vue&type=script&lang=js"
export * from "./LabelDetail.vue?vue&type=script&lang=js"

import "./LabelDetail.vue?vue&type=style&index=0&id=8d100cfe&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d100cfe"]])

export default __exports__